export const PLAZA_DWELL_BUCKETS = ['under_30s', '30s_to_3m', 'over_3m'];
const ACTION_BITS = { avatar: 1, speech: 2, like: 4, friend: 8 };
export function plazaVisitMetrics(rows) {
  if (!Array.isArray(rows)) return null;
  const total = { visits: 0, avatar: 0, speech: 0, like: 0, friend: 0, social: 0, dwell: Object.fromEntries(PLAZA_DWELL_BUCKETS.map(key => [key, 0])), daily: {} };
  for (const row of rows) {
    const count = Number(row.event_count);
    const mask = Number(row.action_mask);
    if (!Number.isSafeInteger(count) || count < 0 || !Number.isInteger(mask) || mask < 0 || mask > 15 || !PLAZA_DWELL_BUCKETS.includes(row.dwell_bucket) || !/^\d{4}-\d{2}-\d{2}$/.test(row.date)) continue;
    total.visits += count;
    total.dwell[row.dwell_bucket] += count;
    total.daily[row.date] = (total.daily[row.date] || 0) + count;
    for (const [action, bit] of Object.entries(ACTION_BITS)) if (mask & bit) total[action] += count;
    if (mask & 14) total.social += count;
  }
  return { ...total, daily: Object.entries(total.daily).sort(([a], [b]) => a.localeCompare(b)).map(([date, count]) => ({ date, count })) };
}
